export const RegistrationSteps = {
  TICKET_SELECTION_STEP: 'TICKET_SELECTION_STEP',
  TICKET_INFORMATION_STEP: 'TICKET_INFORMATION_STEP',
  BILLING_INFORMATION_STEP: 'BILLING_INFORMATION_STEP',
  UPDATE_USER_DATA_STEP: 'UPDATE_USER_DATA_STEP',
};

export const PayWhen = {
  PAY_LATER: 'PAY_LATER',
  PAY_NOW: 'PAY_NOW',
  PAY_NEVER: 'PAY_NEVER',
};
